export default "__VITE_ASSET__DxWcQpzw__"